export default "__VITE_ASSET__4b4e3b7e__"